<template>
    <div class="col-md-2 menu-links d-flex flex-column flex-fill sticky-top">
        <div class="row menu-links-header">
            <div class="col-md-9 pt-3 pr-0">
                <img v-if="0" src="@/assets/svg/chevron-down-FFFFFF.svg" alt="">
                <span v-if="0">{{ accountName }}</span><span>TRW</span>
                <div v-if="0" class="pt-2 d-flex">
                    <img class="menu-link-header-item" src="@/assets/svg/menu-ffffff.svg">
                    <img class="menu-link-header-item" src="@/assets/svg/search-ffffff.svg">
                    <div class="switch pt-1 mr-2">
                        <label>
                            <input type="checkbox">
                            <span class="lever"></span>
                        </label>
                    </div>
                    <span>Test</span>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
        <p class="pt-3">Europa</p>
        <navigation-static
            v-if="navigationType === 'static' && itemsReady"
            :navItems="nav.data"
            :parentClass="parentClass"
        ></navigation-static>
        <navigation-dynamic
            v-if="navigationType === 'dynamic' && itemsReady"
            :navItems="nav.data"
            :parentClass="parentClass"
        ></navigation-dynamic>
        <div class="row menu-links-footer">
            <div class="col-md-9 pr-2">
                <div class="d-flex flex-row justify-content-center pt-3">
                    <div class="d-flex flex-row justify-content-between align-items-center px-2 mr-1" @click="selectLanguage">
                        <div >
                            <img :src="flag" width="14px" :alt="$i18n.locale" />
                        </div>
                        <div>
                            <span>{{ $i18n.locale }}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-content-between align-items-center px-3 ml-1">
                        <div>
                            <span>€</span>
                        </div>
                        <div>
                            <span>Eur</span>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-row align-items-center justify-content-center pt-3">
                    <div class="profile-picture d-flex justify-content-center align-items-start pt-2 mr-2">
                        <img src="@/assets/svg/user-check-dddddd.svg">
                    </div>
                    <div>
                        <span class="ml-2 user-name">{{ user }}</span>
                        <span v-if="isLoggedIn"> | <a @click="logout">{{ $t('general.logout') }}</a></span>
                    </div>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
    </div>
</template>

<script>
import Navigation from '@/services/Navigation'

export default {
  data () {
    return {
      user: this.$store.getters.user,
      accountName: this.$store.getters.account.name,
      nav: {
        data: []
      },
      dynamicNav: {
        data: []
      },
      parentClass: 'current'
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    navigationType () {
      return (this.$route.meta.navigationType || 'dynamic')
    },
    flag () {
      return require(`@/assets/svg/flag-${this.$root.$i18n.locale}.svg`)
    },
    itemsReady () {
      return this.nav.data.length
    }
  },
  async created () {
    this.dynamicNav = await Navigation.getAllFake()
    this.nav = this.$_.clone(this.dynamicNav)
  },
  methods: {
    selectLanguage: function () {
      this.$root.$i18n.locale = this.$root.$i18n.locale === 'en' ? 'nl' : 'en'
      this.$store.commit('locale', this.$root.$i18n.locale)
    },
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
    },
    getOccupancyType (serviceType) {
      let occupancyType = null
      switch (serviceType) {
        case 'accommodation':
          occupancyType = 'room_type'
          break
        case 'transport':
          occupancyType = 'transport_type'
          break
        case 'boat':
          occupancyType = 'boat_type'
          break
        case 'airplane':
          occupancyType = 'airplane_type'
          break
        case 'bus':
          occupancyType = 'bus_type'
          break
        case 'transfer':
          occupancyType = 'transfer_type'
          break
        case 'tour':
          occupancyType = 'tour_type'
          break
        case 'own_cost':
          occupancyType = 'own_cost_type'
          break
        case 'insurance':
          occupancyType = 'insurance_type'
          break
      }
      return occupancyType
    }
  },
  watch: {
    '$route' () {
      let path = this.$route.path.split('/')
      this.parentClass = 'current'
      if (path.length > 3) {
        let serviceType = this.$route.params.service_type
        let id = this.$route.params.id
        // Get the new navs (todo: refactor the whole navigation thing)
        if (serviceType && id) {
          if (serviceType === 'transfer') {
            this.nav.data = [
              {
                name: 'nav.service-type.nav.info',
                path: '/' + path[1] + '/' + serviceType + '/' + id
              },
              {
                name: 'nav.service-type.nav.occupancy',
                path: '/' + path[1] + '/' + serviceType + '/' + id + '/' + this.getOccupancyType(serviceType)
              },
              {
                name: 'nav.service-type.nav.inventory',
                path: '/' + path[1] + '/' + serviceType + '/' + id + '/inventory'
              },
              {
                name: 'nav.service-type.nav.list',
                path: '/' + path[1] + '/' + serviceType + '/' + id + '/list'
              },
              // {
              //   name: 'nav.service-type.nav.facilities',
              //   path: '/' + path[1] + '/' + serviceType + '/' + id + '/facilities'
              // },
              {
                name: 'nav.service-type.nav.documents',
                path: '/' + path[1] + '/' + serviceType + '/' + id + '/documents'
              },
              {
                name: 'nav.service-type.nav.contact',
                path: '/' + path[1] + '/' + serviceType + '/' + id + '/contact'
              }
              // {
              //   name: 'nav.service-type.nav.content',
              //   path: '/' + path[1] + '/' + serviceType + '/' + id + '/content'
              // },
              // {
              //   name: 'nav.service-type.nav.reviews',
              //   path: '/' + path[1] + '/' + serviceType + '/' + id + '/reviews'
              // }
            ]
          } else {
            this.nav.data = [
              {
                name: 'nav.service-type.nav.info',
                path: '/' + path[1] + '/' + serviceType + '/' + id
              },
              {
                name: 'nav.service-type.nav.occupancy',
                path: '/' + path[1] + '/' + serviceType + '/' + id + '/' + this.getOccupancyType(serviceType)
              },
              {
                name: 'nav.service-type.nav.inventory',
                path: '/' + path[1] + '/' + serviceType + '/' + id + '/inventory'
              },
              // {
              //   name: 'nav.service-type.nav.facilities',
              //   path: '/' + path[1] + '/' + serviceType + '/' + id + '/facilities'
              // },
              {
                name: 'nav.service-type.nav.documents',
                path: '/' + path[1] + '/' + serviceType + '/' + id + '/documents'
              },
              {
                name: 'nav.service-type.nav.contact',
                path: '/' + path[1] + '/' + serviceType + '/' + id + '/contact'
              }
              // {
              //   name: 'nav.service-type.nav.content',
              //   path: '/' + path[1] + '/' + serviceType + '/' + id + '/content'
              // },
              // {
              //   name: 'nav.service-type.nav.reviews',
              //   path: '/' + path[1] + '/' + serviceType + '/' + id + '/reviews'
              // }
            ]
          }
        } else {
          this.nav = this.nav = this.$_.clone(this.dynamicNav)
        }
      } else {
        this.nav = this.nav = this.$_.clone(this.dynamicNav)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Sidebar.vue